<template>
    <el-drawer :title="drawer.title" :visible.sync="drawer.visible" size="30%" :before-close="closeDrawer">
        <div class="drawer-form">
            <el-form :model="ruleForm" :rules="rules" ref="platformRuleForm" labelPosition="top" class="ruleForm">
                <el-form-item label="角色名称" prop="title">
                    <el-input v-model="ruleForm.title"></el-input>
                </el-form-item>
                <el-form-item label="角色性质" prop="auth_type">
                    <el-select v-model="ruleForm.auth_type" clearable filterable class="select with100" placeholder="角色性质">
                        <el-option v-for="item in authTypeList" :key="item.id" :label="item.title" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择节点" prop="rules">
                    <el-tree ref="tree" :data="treeData" show-checkbox node-key="id"> </el-tree>
                </el-form-item>
                <el-form-item label="渠道搜索" prop="is_valid">
                    <el-select v-model="ruleForm.is_search_source" placeholder="渠道搜索">
                        <el-option label="是" value="1"></el-option>
                        <el-option label="否" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="看板模块">
                    <el-checkbox-group v-model="dashboard">
                        <el-checkbox class="check-item" v-for="item in moduleList" :label="item.name" :key="item.name">
                            <span>{{ item.title }}</span></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input v-model="ruleForm.sort"></el-input>
                </el-form-item>
                <el-form-item label="上/下线" prop="is_valid">
                    <el-select v-model="ruleForm.is_valid" placeholder="上/下线">
                        <el-option label="上线" value="1"></el-option>
                        <el-option label="下线" value="0"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="submitForm('platformRuleForm')">保存</el-button>
                    <el-button @click="resetForm('platformRuleForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-drawer>
</template>

<script>
export default {
    data() {
        return {
            drawer: {
                title: '',
                visible: false
            },
            authTypeList: [{
                id: 0,
                title: '员工'
            },
            {
                id: 1,
                title: '管理者'
            }
            ],
            moduleList: [{
                name: 'recommend',
                title: '推荐组'
            },
            {
                name: 'wash',
                title: '清洗组'
            }
            ],
            // 权限树
            treeData: [],
            // 用户已有权限
            hasChecked: [],
            ruleForm: {
                id: 0,
                title: '',
                auth_type: '',
                is_search_source: '',
                sort: 0,
                is_valid: '1',
                checked: [],
                rules: [],
                dashboard: []
            },
            dashboard: [],
            rules: {
                title: [{
                    required: true,
                    message: '请输入平台名称',
                    trigger: 'blur'
                },
                {
                    min: 3,
                    max: 100,
                    message: '长度在 3 到 100 个字符',
                    trigger: 'blur'
                }
                ]
            }
        };
    },
    created() {
        this.getTreeData();
    },
    methods: {
        showDrawer(options) {
            let that = this;
            if (options == '') {
                this.drawer.title = '添加角色';
            } else {
                this.drawer.title = '编辑角色';
            }
            this.drawer.visible = true;
            if (options != '') {
                let url = '/api/auth.role/read';
                this.$post(url, options).then(function (response) {
                    if (response.code == '200') {
                        that.ruleForm = response.data.row;
                        that.ruleForm.is_valid = that.ruleForm.is_valid + '';
                        that.ruleForm.is_search_source = that.ruleForm.is_search_source + '';
                        // 该用户已有的权限
                        if (response.data.row.checked) {
                            that.hasChecked = response.data.row.checked;
                            let newArr = [];
                            that.hasChecked.forEach(item => {
                                // item是已有的id，将已有的id与全部id进行匹配，找到父id并删除
                                that.checked(item, that.treeData, newArr)
                            });
                            that.hasChecked = newArr;
                            that.$refs.tree.setCheckedKeys(that.hasChecked)
                            that.dashboard = JSON.parse(that.ruleForm.dashboard != null ? that.ruleForm.dashboard : '[]');
                        }
                    } else {
                        this.$message(response.msg);
                    }
                });
            } else {
                this.$nextTick(() => {
                    this.resetForm('platformRuleForm');
                })

            }
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        closeDrawer() {
            this.hasChecked = []
            this.drawer.visible = false
            this.ruleForm = {
                id: 0,
                title: '',
                auth_type: '',
                sort: 0,
                is_valid: '1',
                checked: [],
                rules: []
            }
            this.dashboard = []
        },

        // 检测id是否是父级id，并将子级id过滤，递归
        checked(id, data, newArr) {
            data.forEach(item => {
                // 在数组中查找属于这个id的item
                if (item.id == id) {
                    // 如果item没有子级或者子级暂时为空就说明他不是父节点或者暂时不是父节点
                    if (item.children == undefined || item.children.length < 1) {
                        newArr.push(item.id)
                    }
                } else {
                    if (item.children != undefined && item.children.length != 0) {
                        this.checked(id, item.children, newArr)
                    }
                }
            });
        },

        // 获取权限树
        getTreeData() {
            let that = this;
            let url = '/api/auth.node/tree';
            let query = this.query;
            this.$post(url, query).then(function (response) {
                let result = response.data;
                that.treeData = result.tree;
            });
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let that = this;
                    let url = '';
                    if (this.ruleForm.id == '') {
                        url = '/api/auth.role/create';
                    } else {
                        url = '/api/auth.role/save';
                    }
                    let checked = that.$refs.tree.getCheckedKeys();
                    let rules = [];
                    let halfChecked = that.$refs.tree.getHalfCheckedKeys();
                    that.ruleForm.rules = rules.concat(halfChecked, checked);
                    that.ruleForm.checked = checked;
                    that.ruleForm.half = halfChecked;
                    that.ruleForm.dashboard = that.dashboard;
                    this.$post(url, that.ruleForm).then(function (response) {
                        if (response.code == '200') {
                            that.$emit('getTableData');
                            that.$message.success(response.msg);
                            that.closeDrawer()
                        } else {
                            that.$message(response.msg);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
    }
};
</script>

<style lang="less" scoped>
@import url('@/assets/css/drawer.less');
@import url('@/assets/css/company.less');
</style>
